import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import PrettyNumber from './PrettyNumber';
import styles from './foundItem.module.scss';
const FoundNumber = ({ number, country, onBuyClickHandle }) => {
    const { region, phone_number } = number;
    const { country_code } = country;
    return (_jsxs("div", Object.assign({ className: classnames(styles.wrapper, 'flags') }, { children: [_jsx("span", { className: classnames('flag', country_code.toLowerCase()) }), _jsx(PrettyNumber, { number: phone_number }), region && _jsx("span", Object.assign({ className: styles.name }, { children: region.toLowerCase() })), _jsx("button", Object.assign({ className: styles.button, onClick: onBuyClickHandle }, { children: "Buy" }))] })));
};
export default FoundNumber;
